/**
 * Generated by orval 🍺
 * Do not edit manually.
 * MyRentalMate API
 * OpenAPI spec version: 0.1.0
 */
import {
  useMutation,
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  CourtDateIn,
  HTTPValidationError,
  LegalCaseIn,
  LegalCaseOut,
  ListLegalCasesParams,
  ListViolationsParams,
  PaginatedLegalCaseOut,
  PaginatedViolationOut,
  ViolationIn,
  ViolationOut
} from '../model';

import { apiFetch } from '../../fetcher';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

export type listViolationsResponse200 = {
  data: PaginatedViolationOut
  status: 200
}

export type listViolationsResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listViolationsResponseSuccess = (listViolationsResponse200) & {
  headers: Headers;
};
export type listViolationsResponseError = (listViolationsResponse422) & {
  headers: Headers;
};

export type listViolationsResponse = (listViolationsResponseSuccess | listViolationsResponseError)

export const getListViolationsUrl = (params?: ListViolationsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/violations?${stringifiedParams}` : `/api/violations`
}

/**
 * @summary List Violations
 */
export const listViolations = async (params?: ListViolationsParams, options?: Parameters<typeof apiFetch>[1]): Promise<listViolationsResponse> => {

  return apiFetch<listViolationsResponse>(getListViolationsUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListViolationsQueryKey = (params?: ListViolationsParams,) => {
    return [
    `/api/violations`, ...(params ? [params] : [])
    ] as const;
    }


export const getListViolationsQueryOptions = <TData = Awaited<ReturnType<typeof listViolations>>, TError = HTTPValidationError>(params?: ListViolationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listViolations>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListViolationsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listViolations>>> = ({ signal }) => listViolations(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listViolations>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListViolationsQueryResult = NonNullable<Awaited<ReturnType<typeof listViolations>>>
export type ListViolationsQueryError = HTTPValidationError


export function useListViolations<TData = Awaited<ReturnType<typeof listViolations>>, TError = HTTPValidationError>(
 params: undefined |  ListViolationsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listViolations>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listViolations>>,
          TError,
          Awaited<ReturnType<typeof listViolations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListViolations<TData = Awaited<ReturnType<typeof listViolations>>, TError = HTTPValidationError>(
 params?: ListViolationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listViolations>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listViolations>>,
          TError,
          Awaited<ReturnType<typeof listViolations>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListViolations<TData = Awaited<ReturnType<typeof listViolations>>, TError = HTTPValidationError>(
 params?: ListViolationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listViolations>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Violations
 */

export function useListViolations<TData = Awaited<ReturnType<typeof listViolations>>, TError = HTTPValidationError>(
 params?: ListViolationsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listViolations>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListViolationsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createViolationResponse201 = {
  data: ViolationOut
  status: 201
}

export type createViolationResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createViolationResponseSuccess = (createViolationResponse201) & {
  headers: Headers;
};
export type createViolationResponseError = (createViolationResponse422) & {
  headers: Headers;
};

export type createViolationResponse = (createViolationResponseSuccess | createViolationResponseError)

export const getCreateViolationUrl = () => {




  return `/api/violations`
}

/**
 * @summary Create Violation
 */
export const createViolation = async (violationIn: ViolationIn, options?: Parameters<typeof apiFetch>[1]): Promise<createViolationResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<createViolationResponse>(getCreateViolationUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(violationIn)
  }
);}





export const getCreateViolationMutationKey = () => ['createViolation'] as const;

export const getCreateViolationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createViolation>>, TError,CreateViolationMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createViolation>>, TError,CreateViolationMutationVariables, TContext> => {

const mutationKey = getCreateViolationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createViolation>>, CreateViolationMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createViolation(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateViolationMutationResult = NonNullable<Awaited<ReturnType<typeof createViolation>>>
    export type CreateViolationMutationBody = ViolationIn
    export type CreateViolationMutationError = HTTPValidationError
    export type CreateViolationMutationVariables = {data: ViolationIn}

    /**
 * @summary Create Violation
 */
export const useCreateViolation = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createViolation>>, TError,CreateViolationMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createViolation>>,
        TError,
        CreateViolationMutationVariables,
        TContext
      > => {
      return useMutation(getCreateViolationMutationOptions(options), queryClient);
    }
    export type updateViolationResponse200 = {
  data: ViolationOut
  status: 200
}

export type updateViolationResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type updateViolationResponseSuccess = (updateViolationResponse200) & {
  headers: Headers;
};
export type updateViolationResponseError = (updateViolationResponse422) & {
  headers: Headers;
};

export type updateViolationResponse = (updateViolationResponseSuccess | updateViolationResponseError)

export const getUpdateViolationUrl = (violationId: number,) => {




  return `/api/violations/${violationId}`
}

/**
 * @summary Update Violation
 */
export const updateViolation = async (violationId: number,
    violationIn: ViolationIn, options?: Parameters<typeof apiFetch>[1]): Promise<updateViolationResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<updateViolationResponse>(getUpdateViolationUrl(violationId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(violationIn)
  }
);}





export const getUpdateViolationMutationKey = () => ['updateViolation'] as const;

export const getUpdateViolationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateViolation>>, TError,UpdateViolationMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateViolation>>, TError,UpdateViolationMutationVariables, TContext> => {

const mutationKey = getUpdateViolationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateViolation>>, UpdateViolationMutationVariables> = (props) => {
          const {violationId,data} = props ?? {};

          return  updateViolation(violationId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateViolationMutationResult = NonNullable<Awaited<ReturnType<typeof updateViolation>>>
    export type UpdateViolationMutationBody = ViolationIn
    export type UpdateViolationMutationError = HTTPValidationError
    export type UpdateViolationMutationVariables = {violationId: number;data: ViolationIn}

    /**
 * @summary Update Violation
 */
export const useUpdateViolation = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateViolation>>, TError,UpdateViolationMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateViolation>>,
        TError,
        UpdateViolationMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateViolationMutationOptions(options), queryClient);
    }
    export type deleteViolationResponse204 = {
  data: void
  status: 204
}

export type deleteViolationResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type deleteViolationResponseSuccess = (deleteViolationResponse204) & {
  headers: Headers;
};
export type deleteViolationResponseError = (deleteViolationResponse422) & {
  headers: Headers;
};

export type deleteViolationResponse = (deleteViolationResponseSuccess | deleteViolationResponseError)

export const getDeleteViolationUrl = (violationId: number,) => {




  return `/api/violations/${violationId}`
}

/**
 * @summary Delete Violation
 */
export const deleteViolation = async (violationId: number, options?: Parameters<typeof apiFetch>[1]): Promise<deleteViolationResponse> => {

  return apiFetch<deleteViolationResponse>(getDeleteViolationUrl(violationId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteViolationMutationKey = () => ['deleteViolation'] as const;

export const getDeleteViolationMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteViolation>>, TError,DeleteViolationMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteViolation>>, TError,DeleteViolationMutationVariables, TContext> => {

const mutationKey = getDeleteViolationMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteViolation>>, DeleteViolationMutationVariables> = (props) => {
          const {violationId} = props ?? {};

          return  deleteViolation(violationId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteViolationMutationResult = NonNullable<Awaited<ReturnType<typeof deleteViolation>>>

    export type DeleteViolationMutationError = HTTPValidationError
    export type DeleteViolationMutationVariables = {violationId: number}

    /**
 * @summary Delete Violation
 */
export const useDeleteViolation = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteViolation>>, TError,DeleteViolationMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteViolation>>,
        TError,
        DeleteViolationMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteViolationMutationOptions(options), queryClient);
    }
    export type listLegalCasesResponse200 = {
  data: PaginatedLegalCaseOut
  status: 200
}

export type listLegalCasesResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type listLegalCasesResponseSuccess = (listLegalCasesResponse200) & {
  headers: Headers;
};
export type listLegalCasesResponseError = (listLegalCasesResponse422) & {
  headers: Headers;
};

export type listLegalCasesResponse = (listLegalCasesResponseSuccess | listLegalCasesResponseError)

export const getListLegalCasesUrl = (params?: ListLegalCasesParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {

    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : String(value))
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/legal-cases?${stringifiedParams}` : `/api/legal-cases`
}

/**
 * @summary List Legal Cases
 */
export const listLegalCases = async (params?: ListLegalCasesParams, options?: Parameters<typeof apiFetch>[1]): Promise<listLegalCasesResponse> => {

  return apiFetch<listLegalCasesResponse>(getListLegalCasesUrl(params),
  {
    ...options,
    method: 'GET'


  }
);}





export const getListLegalCasesQueryKey = (params?: ListLegalCasesParams,) => {
    return [
    `/api/legal-cases`, ...(params ? [params] : [])
    ] as const;
    }


export const getListLegalCasesQueryOptions = <TData = Awaited<ReturnType<typeof listLegalCases>>, TError = HTTPValidationError>(params?: ListLegalCasesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLegalCases>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getListLegalCasesQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof listLegalCases>>> = ({ signal }) => listLegalCases(params, { signal, ...requestOptions });





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof listLegalCases>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type ListLegalCasesQueryResult = NonNullable<Awaited<ReturnType<typeof listLegalCases>>>
export type ListLegalCasesQueryError = HTTPValidationError


export function useListLegalCases<TData = Awaited<ReturnType<typeof listLegalCases>>, TError = HTTPValidationError>(
 params: undefined |  ListLegalCasesParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLegalCases>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLegalCases>>,
          TError,
          Awaited<ReturnType<typeof listLegalCases>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLegalCases<TData = Awaited<ReturnType<typeof listLegalCases>>, TError = HTTPValidationError>(
 params?: ListLegalCasesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLegalCases>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listLegalCases>>,
          TError,
          Awaited<ReturnType<typeof listLegalCases>>
        > , 'initialData'
      >, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useListLegalCases<TData = Awaited<ReturnType<typeof listLegalCases>>, TError = HTTPValidationError>(
 params?: ListLegalCasesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLegalCases>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
/**
 * @summary List Legal Cases
 */

export function useListLegalCases<TData = Awaited<ReturnType<typeof listLegalCases>>, TError = HTTPValidationError>(
 params?: ListLegalCasesParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof listLegalCases>>, TError, TData>>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getListLegalCasesQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  return withQueryKey(query, queryOptions.queryKey);
}






export type createLegalCaseResponse201 = {
  data: LegalCaseOut
  status: 201
}

export type createLegalCaseResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type createLegalCaseResponseSuccess = (createLegalCaseResponse201) & {
  headers: Headers;
};
export type createLegalCaseResponseError = (createLegalCaseResponse422) & {
  headers: Headers;
};

export type createLegalCaseResponse = (createLegalCaseResponseSuccess | createLegalCaseResponseError)

export const getCreateLegalCaseUrl = () => {




  return `/api/legal-cases`
}

/**
 * @summary Create Legal Case
 */
export const createLegalCase = async (legalCaseIn: LegalCaseIn, options?: Parameters<typeof apiFetch>[1]): Promise<createLegalCaseResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<createLegalCaseResponse>(getCreateLegalCaseUrl(),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(legalCaseIn)
  }
);}





export const getCreateLegalCaseMutationKey = () => ['createLegalCase'] as const;

export const getCreateLegalCaseMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLegalCase>>, TError,CreateLegalCaseMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof createLegalCase>>, TError,CreateLegalCaseMutationVariables, TContext> => {

const mutationKey = getCreateLegalCaseMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof createLegalCase>>, CreateLegalCaseMutationVariables> = (props) => {
          const {data} = props ?? {};

          return  createLegalCase(data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type CreateLegalCaseMutationResult = NonNullable<Awaited<ReturnType<typeof createLegalCase>>>
    export type CreateLegalCaseMutationBody = LegalCaseIn
    export type CreateLegalCaseMutationError = HTTPValidationError
    export type CreateLegalCaseMutationVariables = {data: LegalCaseIn}

    /**
 * @summary Create Legal Case
 */
export const useCreateLegalCase = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof createLegalCase>>, TError,CreateLegalCaseMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof createLegalCase>>,
        TError,
        CreateLegalCaseMutationVariables,
        TContext
      > => {
      return useMutation(getCreateLegalCaseMutationOptions(options), queryClient);
    }
    export type updateLegalCaseResponse200 = {
  data: LegalCaseOut
  status: 200
}

export type updateLegalCaseResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type updateLegalCaseResponseSuccess = (updateLegalCaseResponse200) & {
  headers: Headers;
};
export type updateLegalCaseResponseError = (updateLegalCaseResponse422) & {
  headers: Headers;
};

export type updateLegalCaseResponse = (updateLegalCaseResponseSuccess | updateLegalCaseResponseError)

export const getUpdateLegalCaseUrl = (caseId: number,) => {




  return `/api/legal-cases/${caseId}`
}

/**
 * @summary Update Legal Case
 */
export const updateLegalCase = async (caseId: number,
    legalCaseIn: LegalCaseIn, options?: Parameters<typeof apiFetch>[1]): Promise<updateLegalCaseResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<updateLegalCaseResponse>(getUpdateLegalCaseUrl(caseId),
  {
    ...options,
    method: 'PUT',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(legalCaseIn)
  }
);}





export const getUpdateLegalCaseMutationKey = () => ['updateLegalCase'] as const;

export const getUpdateLegalCaseMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLegalCase>>, TError,UpdateLegalCaseMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof updateLegalCase>>, TError,UpdateLegalCaseMutationVariables, TContext> => {

const mutationKey = getUpdateLegalCaseMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof updateLegalCase>>, UpdateLegalCaseMutationVariables> = (props) => {
          const {caseId,data} = props ?? {};

          return  updateLegalCase(caseId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type UpdateLegalCaseMutationResult = NonNullable<Awaited<ReturnType<typeof updateLegalCase>>>
    export type UpdateLegalCaseMutationBody = LegalCaseIn
    export type UpdateLegalCaseMutationError = HTTPValidationError
    export type UpdateLegalCaseMutationVariables = {caseId: number;data: LegalCaseIn}

    /**
 * @summary Update Legal Case
 */
export const useUpdateLegalCase = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof updateLegalCase>>, TError,UpdateLegalCaseMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof updateLegalCase>>,
        TError,
        UpdateLegalCaseMutationVariables,
        TContext
      > => {
      return useMutation(getUpdateLegalCaseMutationOptions(options), queryClient);
    }
    export type deleteLegalCaseResponse204 = {
  data: void
  status: 204
}

export type deleteLegalCaseResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type deleteLegalCaseResponseSuccess = (deleteLegalCaseResponse204) & {
  headers: Headers;
};
export type deleteLegalCaseResponseError = (deleteLegalCaseResponse422) & {
  headers: Headers;
};

export type deleteLegalCaseResponse = (deleteLegalCaseResponseSuccess | deleteLegalCaseResponseError)

export const getDeleteLegalCaseUrl = (caseId: number,) => {




  return `/api/legal-cases/${caseId}`
}

/**
 * @summary Delete Legal Case
 */
export const deleteLegalCase = async (caseId: number, options?: Parameters<typeof apiFetch>[1]): Promise<deleteLegalCaseResponse> => {

  return apiFetch<deleteLegalCaseResponse>(getDeleteLegalCaseUrl(caseId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getDeleteLegalCaseMutationKey = () => ['deleteLegalCase'] as const;

export const getDeleteLegalCaseMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLegalCase>>, TError,DeleteLegalCaseMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof deleteLegalCase>>, TError,DeleteLegalCaseMutationVariables, TContext> => {

const mutationKey = getDeleteLegalCaseMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof deleteLegalCase>>, DeleteLegalCaseMutationVariables> = (props) => {
          const {caseId} = props ?? {};

          return  deleteLegalCase(caseId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type DeleteLegalCaseMutationResult = NonNullable<Awaited<ReturnType<typeof deleteLegalCase>>>

    export type DeleteLegalCaseMutationError = HTTPValidationError
    export type DeleteLegalCaseMutationVariables = {caseId: number}

    /**
 * @summary Delete Legal Case
 */
export const useDeleteLegalCase = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof deleteLegalCase>>, TError,DeleteLegalCaseMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof deleteLegalCase>>,
        TError,
        DeleteLegalCaseMutationVariables,
        TContext
      > => {
      return useMutation(getDeleteLegalCaseMutationOptions(options), queryClient);
    }
    export type addCourtDateResponse200 = {
  data: LegalCaseOut
  status: 200
}

export type addCourtDateResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type addCourtDateResponseSuccess = (addCourtDateResponse200) & {
  headers: Headers;
};
export type addCourtDateResponseError = (addCourtDateResponse422) & {
  headers: Headers;
};

export type addCourtDateResponse = (addCourtDateResponseSuccess | addCourtDateResponseError)

export const getAddCourtDateUrl = (caseId: number,) => {




  return `/api/legal-cases/${caseId}/court-dates`
}

/**
 * @summary Add Court Date
 */
export const addCourtDate = async (caseId: number,
    courtDateIn: CourtDateIn, options?: Parameters<typeof apiFetch>[1]): Promise<addCourtDateResponse> => {

    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
    if (!h) return {};
    if (h instanceof Headers) return Object.fromEntries(h.entries());
    if (Symbol.iterator in h) {
      return Object.fromEntries(
        Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string]),
      );
    }
    const headers: Record<string, string | readonly string[]> = {};
    for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
      if (value !== undefined) headers[name] = value;
    }
    return headers;
  };
return apiFetch<addCourtDateResponse>(getAddCourtDateUrl(caseId),
  {
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
    body: JSON.stringify(courtDateIn)
  }
);}





export const getAddCourtDateMutationKey = () => ['addCourtDate'] as const;

export const getAddCourtDateMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCourtDate>>, TError,AddCourtDateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof addCourtDate>>, TError,AddCourtDateMutationVariables, TContext> => {

const mutationKey = getAddCourtDateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof addCourtDate>>, AddCourtDateMutationVariables> = (props) => {
          const {caseId,data} = props ?? {};

          return  addCourtDate(caseId,data,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type AddCourtDateMutationResult = NonNullable<Awaited<ReturnType<typeof addCourtDate>>>
    export type AddCourtDateMutationBody = CourtDateIn
    export type AddCourtDateMutationError = HTTPValidationError
    export type AddCourtDateMutationVariables = {caseId: number;data: CourtDateIn}

    /**
 * @summary Add Court Date
 */
export const useAddCourtDate = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof addCourtDate>>, TError,AddCourtDateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof addCourtDate>>,
        TError,
        AddCourtDateMutationVariables,
        TContext
      > => {
      return useMutation(getAddCourtDateMutationOptions(options), queryClient);
    }
    export type removeCourtDateResponse200 = {
  data: LegalCaseOut
  status: 200
}

export type removeCourtDateResponse422 = {
  data: HTTPValidationError
  status: 422
}

export type removeCourtDateResponseSuccess = (removeCourtDateResponse200) & {
  headers: Headers;
};
export type removeCourtDateResponseError = (removeCourtDateResponse422) & {
  headers: Headers;
};

export type removeCourtDateResponse = (removeCourtDateResponseSuccess | removeCourtDateResponseError)

export const getRemoveCourtDateUrl = (caseId: number,
    courtDateId: number,) => {




  return `/api/legal-cases/${caseId}/court-dates/${courtDateId}`
}

/**
 * @summary Remove Court Date
 */
export const removeCourtDate = async (caseId: number,
    courtDateId: number, options?: Parameters<typeof apiFetch>[1]): Promise<removeCourtDateResponse> => {

  return apiFetch<removeCourtDateResponse>(getRemoveCourtDateUrl(caseId,courtDateId),
  {
    ...options,
    method: 'DELETE'


  }
);}





export const getRemoveCourtDateMutationKey = () => ['removeCourtDate'] as const;

export const getRemoveCourtDateMutationOptions = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCourtDate>>, TError,RemoveCourtDateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
): UseMutationOptions<Awaited<ReturnType<typeof removeCourtDate>>, TError,RemoveCourtDateMutationVariables, TContext> => {

const mutationKey = getRemoveCourtDateMutationKey();
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};




      const mutationFn: MutationFunction<Awaited<ReturnType<typeof removeCourtDate>>, RemoveCourtDateMutationVariables> = (props) => {
          const {caseId,courtDateId} = props ?? {};

          return  removeCourtDate(caseId,courtDateId,requestOptions)
        }






  return  { mutationFn, ...mutationOptions }}

    export type RemoveCourtDateMutationResult = NonNullable<Awaited<ReturnType<typeof removeCourtDate>>>

    export type RemoveCourtDateMutationError = HTTPValidationError
    export type RemoveCourtDateMutationVariables = {caseId: number;courtDateId: number}

    /**
 * @summary Remove Court Date
 */
export const useRemoveCourtDate = <TError = HTTPValidationError,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof removeCourtDate>>, TError,RemoveCourtDateMutationVariables, TContext>, request?: SecondParameter<typeof apiFetch>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof removeCourtDate>>,
        TError,
        RemoveCourtDateMutationVariables,
        TContext
      > => {
      return useMutation(getRemoveCourtDateMutationOptions(options), queryClient);
    }
